import {
  Component,
  HostListener,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  Inject, PLATFORM_ID
} from '@angular/core';
import {Observable} from "rxjs";
import {VoteOptionsModel} from "../../../../models/vote-options.model";
import {CandidateType, CandidateTypes, VoteTypes} from "../../../../types";
import {VoteModel} from "../../../../models/vote.model";
import {VoteCardComponent} from "../vote-card/vote-card.component";
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-vote-section',
  templateUrl: './vote-section.component.html',
  styleUrls: ['./vote-section.component.scss']
})
export class VoteSectionComponent {
  @Input() options$: Observable<VoteOptionsModel>;
  @Input() type: CandidateType;
  votes: VoteModel[] = [];
  @Output() voteEmitter = new EventEmitter<VoteModel[]>();
  screenWidth: number;
  count = 0;

  @ViewChildren('card')
  cardInputs: QueryList<VoteCardComponent>;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenWidth(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
    }
  }

  emitVote(vote: VoteModel, allowedCount: number): void {
    if (this.count <= allowedCount) {
      const existingVote = this.votes.find(v => v.candidateId === vote.candidateId)
      if (existingVote) {
        if (existingVote.vote === vote.vote) {
          if (vote.vote === VoteTypes.DA) {
            this.count--;
          }
          this.votes = this.votes.filter(v => v.candidateId !== vote.candidateId);
        }
        else {
          if (vote.vote === VoteTypes.DA) {
            this.count++;
          }
          if (existingVote.vote === VoteTypes.DA) {
            this.count--;
          }
          this.votes[this.votes.indexOf(existingVote)] = vote;
        }
      }
      else {
        if (vote.vote === VoteTypes.DA) {
          this.count++;
        }
        this.votes = [...this.votes, vote];
      }
      this.voteEmitter.emit(this.votes);
    }
  }
}
